/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/**
 * Export all prefixes for location field related input hidden fields names
 */
var fieldName$4 = "EGDSSearchFormLocationField";
var locationPrefix = fieldName$4 + "-Location";
var regionIdPrefix = fieldName$4 + "-RegionId";
var latPrefix = fieldName$4 + "-Lat";
var longPrefix = fieldName$4 + "-Long";
var deeplinkPrefix = fieldName$4 + "-Values";
var selectedPrefix = fieldName$4 + "-Selected";

/**
 * Export all prefixes for date picker field related input hidden fields names
 */
var fieldName$3 = "EGDSDateRangePicker";
var startDatePrefix = fieldName$3 + "-StartDate";
var endDatePrefix = fieldName$3 + "-EndDate";

/**
 * Export all prefixes for travelers field related input hidden fields names
 */
var fieldName$2 = "EGDSSearchFormTravelersField";
var adultPrefix = fieldName$2 + "-Adult-Room";
var childrenAgePrefix = fieldName$2 + "-ChildrenAge-Room";

/**
 * Export all prefixes for basic traveler selector related input hidden fields names
 */
var fieldName$1 = "EGDSSearchFormTravelersField";
var adultBasicPrefix = fieldName$1 + "-Adult";
var childrenAgeBasicPrefix = fieldName$1 + "-ChildrenAge";
var petsBasicPrefix = fieldName$1 + "-Pets";

/**
 * Export all prefixes for duration span field related input hidden fields names
 */
var fieldName = "SearchFormDurationSpanField";
var minDurationPrefix = fieldName + "-Min";
var maxDurationPrefix = fieldName + "-Max";

/**
 * Based on a collection of form inputs, generate a valid string that represent a user search in a format
 * that Lodging search results page can handle
 * @param inputs Form inputs for getting the values to build the query parameters
 * @returns Query parameters for lodging results page (/Hotel-Search)
 * ?location=Guadalajara
    &rid=1295
    &startDate=2022-08-29
    &endDate=2022-08-31
    &d1=2022-08-29
    &d2=2022-08-31
 */
var activitiesStrategy = function (inputs) {
    var queryParamsMap = inputs.reduce(function (prev, _a) {
        var name = _a.name, value = _a.value;
        // Location
        if (name.startsWith(locationPrefix)) {
            return __assign(__assign({}, prev), { location: value });
        }
        // Region Id
        if (name.startsWith(regionIdPrefix)) {
            return __assign(__assign({}, prev), { rid: value });
        }
        // Dates field
        if (name.startsWith(startDatePrefix)) {
            return __assign(__assign({}, prev), { d1: value, startDate: value });
        }
        if (name.startsWith(endDatePrefix)) {
            return __assign(__assign({}, prev), { d2: value, endDate: value });
        }
        return prev;
    }, {});
    var queryParamsString = Object.keys(queryParamsMap)
        .map(function (key) { return key + "=" + queryParamsMap[key]; })
        .join('&');
    return "?" + queryParamsString;
};

/**
 * Based on a collection of form inputs, generate a valid string that represent a user search in a format
 * that Cruise search results page can handle
 * @param inputs Form inputs for getting the values to build the query parameters
 * @returns Query parameters for cruise results page (/Cruise-Search)
 * ?destination=alaska|bahamas
    &adultCount=4
    &childCount=2
    &childAges=5,9
    &earliest-departure-date=2022-06-10
    &latest-departure-date=2022-07-09
    &min-length=5
    &max-length=9
 */
var cruiseStrategy = function (inputs) {
    var queryParamsMap = inputs.reduce(function (prev, _a) {
        var name = _a.name, value = _a.value;
        // Location field
        if (name.startsWith(deeplinkPrefix)) {
            return __assign(__assign({}, prev), { destination: value.replace(/,/g, '|') });
        }
        // Dates field
        if (name.startsWith(startDatePrefix)) {
            return __assign(__assign({}, prev), { 'earliest-departure-date': value });
        }
        if (name.startsWith(endDatePrefix)) {
            return __assign(__assign({}, prev), { 'latest-departure-date': value });
        }
        // Duration span field
        if (name.startsWith(minDurationPrefix)) {
            return __assign(__assign({}, prev), { 'min-length': value });
        }
        if (name.startsWith(maxDurationPrefix)) {
            return __assign(__assign({}, prev), { 'max-length': value });
        }
        // Travelers field
        if (name.startsWith(adultBasicPrefix)) {
            return __assign(__assign({}, prev), { adultCount: value });
        }
        if (name.startsWith(childrenAgeBasicPrefix)) {
            var prevChildren = prev.childAges;
            var childAges = prevChildren ? prevChildren + "," + value : value;
            var childCount = childAges.split(',').length;
            return __assign(__assign({}, prev), { childCount: childCount, childAges: childAges });
        }
        return prev;
    }, {});
    var queryParamsString = Object.keys(queryParamsMap)
        .map(function (key) { return key + "=" + queryParamsMap[key]; })
        .join('&');
    return "?" + queryParamsString;
};

/**
 * Export all EGDS_ELEMENT_IDS related input hidden fields names
 */
var flightTypeEgdsElementId = 'flight_type_selector';
var cabinClassEgdsElementId = 'cabin_class';
var destinationEgdsElementId = 'destination_select';
var originEgdsElementId = 'origin_select';

/**
 * Based on a collection of form inputs, generate a valid string that represent a user search in a format
 * that Flight search results page can handle
 * @param inputs Form inputs for getting the values to build the query parameters
 * @returns Query parameters for Flight results page (/Flight-Search)
 * ?flight-type=on
    &mode=search
    &trip=oneway
    &leg1=from%3AGuadalajara+%28GDL+-+Don+Miguel+Hidalgo+y+Costilla+Intl.%29%2Cto%3ASeattle+%28SEA+-+Seattle-Tacoma+Intl.%29%2Cdeparture%3A6%2F19%2F2022TANYT
    &options=cabinclass%3Aeconomy
    &passengers=children%3A0%2Cadults%3A1%2Cseniors%3A0%2Cinfantinlap%3AY
    &fromDate=6%2F19%2F2022

    -- structures --
    leg=from:Guadalajara+(GDL+-+Don+Miguel+Hidalgo+y+Costilla+Intl.),to:Seattle+(SEA+-+Seattle-Tacoma+Intl.),departure:6/19/2022TANYT
    passengers=children:3[0,12,13],adults:1,seniors:0,infantinlap:Y
    options=cabinclass:economy
 */
var flightTypeMap = {
    ONE_WAY: 'oneway',
    ROUND_TRIP: 'roundtrip',
    MULTI_DESTINATION: 'multi'
};
var flightStrategy = function (inputs) {
    // Need to figure out all the legs logic for multicity, also need to check the index once we add it in shared-ui
    var leg = {
        from: '',
        to: '',
        departureDate: ''
    };
    var passengers = {
        adults: 0,
        seniors: 0,
        childAges: []
    };
    var queryParamsMap = inputs.reduce(function (prev, _a) {
        var name = _a.name, value = _a.value;
        if (name.includes(flightTypeEgdsElementId)) {
            return __assign(__assign({}, prev), { trip: flightTypeMap[value] });
        }
        if (name.includes(cabinClassEgdsElementId)) {
            return __assign(__assign({}, prev), { options: "cabinclass:" + value });
        }
        if (name.startsWith(locationPrefix) && name.includes(originEgdsElementId)) {
            leg.from = value;
            return prev;
        }
        if (name.startsWith(locationPrefix) && name.includes(destinationEgdsElementId)) {
            leg.to = value;
            return prev;
        }
        // Dates field
        if (name.startsWith(startDatePrefix)) {
            leg.departureDate = value;
            return __assign(__assign({}, prev), { fromDate: value });
        }
        // Travelers field
        if (name.startsWith(adultBasicPrefix)) {
            passengers.adults = +value;
            return prev;
        }
        if (name.startsWith(childrenAgeBasicPrefix)) {
            passengers.childAges.push(value);
            return prev;
        }
        return prev;
    }, { 'flight-type': 'on', mode: 'search' });
    // TODO: logic for one way
    var childCount = passengers.childAges.length || 0;
    var childAges = childCount ? childCount + "[" + passengers.childAges.join(';') + "]" : childCount.toString();
    queryParamsMap.legs = [leg];
    queryParamsMap.passengers = "children:" + childAges + ",adults:" + passengers.adults + ",seniors:0,infantinlap:Y";
    var queryParamsString = Object.keys(queryParamsMap)
        .map(function (key) {
        if (key === 'legs' && queryParamsMap.legs) {
            return queryParamsMap.legs
                .map(function (value, index) { return "leg" + (index + 1) + "=from:" + value.from + ",to:" + value.to + ",departure:" + value.departureDate + "TANYT"; })
                .join('&');
        }
        return key + "=" + queryParamsMap[key];
    })
        .join('&');
    return "?" + queryParamsString;
};

var EGDSCheckBoxState;
(function (EGDSCheckBoxState) {
    EGDSCheckBoxState["CHECKED"] = "CHECKED";
    EGDSCheckBoxState["INDETERMINATE"] = "INDETERMINATE";
    EGDSCheckBoxState["UNCHECKED"] = "UNCHECKED";
})(EGDSCheckBoxState || (EGDSCheckBoxState = {}));
/**
 * Based on a collection of form inputs, generate a valid string that represent a user search in a format
 * that Lodging search results page can handle
 * @param inputs Form inputs for getting the values to build the query parameters
 * @returns Query parameters for lodging results page (/Hotel-Search)
 * ?destination=New York
    &regionId=178293
    &latLong=40.75668,-73.98647
    &d1=2021-11-25
    &d2=2021-11-26
    &startDate=2021-11-25
    &endDate=2021-11-26
    &rooms=2
    &adults=2,2
    &children=2_7,2_12
    &isPets=true
    &amenities=PETS
    &selected=41009
 */
var lodgingStrategy = function (inputs) {
    var queryParamsMap = inputs.reduce(function (prev, _a) {
        var name = _a.name, value = _a.value;
        // Location field
        if (name.startsWith(locationPrefix)) {
            return __assign(__assign({}, prev), { destination: value });
        }
        if (name.startsWith(regionIdPrefix)) {
            return __assign(__assign({}, prev), { regionId: value });
        }
        if (name.startsWith(latPrefix)) {
            return __assign(__assign({}, prev), { latLong: value });
        }
        if (name.startsWith(longPrefix)) {
            return __assign(__assign({}, prev), { latLong: prev.latLong + "," + value });
        }
        // Dates field
        if (name.startsWith(startDatePrefix)) {
            return __assign(__assign({}, prev), { d1: value, startDate: value });
        }
        if (name.startsWith(endDatePrefix)) {
            return __assign(__assign({}, prev), { d2: value, endDate: value });
        }
        // Travelers field
        if (name.startsWith(adultPrefix)) {
            var prevAdults = prev.adults;
            var adults = prevAdults ? prevAdults + "," + value : value;
            return __assign(__assign({}, prev), { adults: adults });
        }
        if (name.startsWith(childrenAgePrefix)) {
            var prevChildren = prev.children;
            var roomNumber = name.substr(childrenAgePrefix.length, 1);
            var formattedValue = roomNumber + "_" + value;
            var children = prevChildren ? prevChildren + "," + formattedValue : formattedValue;
            return __assign(__assign({}, prev), { children: children });
        }
        // Basic travelers field
        if (name.startsWith(adultBasicPrefix)) {
            return __assign(__assign({}, prev), { adults: value });
        }
        if (name.startsWith(childrenAgeBasicPrefix)) {
            var prevChildren = prev.children;
            var roomNumber = 1;
            var formattedValue = roomNumber + "_" + value;
            var children = prevChildren ? prevChildren + "," + formattedValue : formattedValue;
            return __assign(__assign({}, prev), { children: children });
        }
        if (name.startsWith(petsBasicPrefix)) {
            var isPets = value === EGDSCheckBoxState.CHECKED;
            return __assign(__assign(__assign({}, prev), { isPets: isPets }), (isPets && { amenities: 'PETS' }));
        }
        // Selected field (used to pin a property)
        if (name.startsWith(selectedPrefix)) {
            return __assign(__assign({}, prev), { selected: value });
        }
        return prev;
    }, {});
    var queryParamsString = Object.keys(queryParamsMap)
        .map(function (key) { return key + "=" + queryParamsMap[key]; })
        .join('&');
    return "?" + queryParamsString;
};

var _a;
/**
 * Available strategies for creating query params
 * Each of these values corresponds to a search results page
 */
var QueryParamsStrategies;
(function (QueryParamsStrategies) {
    QueryParamsStrategies["LODGING"] = "LODGING";
    QueryParamsStrategies["CRUISES"] = "CRUISES";
    QueryParamsStrategies["FLIGHTS"] = "FLIGHTS";
    QueryParamsStrategies["ACTIVITIES"] = "ACTIVITIES";
})(QueryParamsStrategies || (QueryParamsStrategies = {}));
/**
 * Query params map for exposing the supported strategies
 */
var queryParamsStrategiesMap = (_a = {},
    _a[QueryParamsStrategies.LODGING] = lodgingStrategy,
    _a[QueryParamsStrategies.CRUISES] = cruiseStrategy,
    _a[QueryParamsStrategies.FLIGHTS] = flightStrategy,
    _a[QueryParamsStrategies.ACTIVITIES] = activitiesStrategy,
    _a);

/**
 * Given a collection of input elements (form children), returns a formatted string with valid query parameters
 * for the desired search-results page
 * @param strategy
 * @param elements Search form children elements
 * @returns Valid query params string for the desired strategy (commonly LOB)
 *
 * @example
 * // returns
 * ?destination=Seattle
    &regionId=1295
    &latLong=20.67702%2C-103.34703
    &d1=2021-11-25
    &d2=2021-11-26
    &startDate=2021-11-25
    &endDate=2021-11-26
    &rooms=1
    &adults=2
 * const queryParams = getSearchToolsQueryParams(QueryParamsStrategies.LODGING)
 */
var getSearchToolsQueryParams = function (strategy, elements) {
    var searchToolsInputPrefix = 'EGDS';
    var searchFrom = 'SearchForm';
    var prefixes = [searchToolsInputPrefix, searchFrom];
    var filteredInputs = elements.filter(function (_a) {
        var name = _a.name;
        return prefixes.find(function (prefix) { return name.startsWith(prefix); });
    });
    return queryParamsStrategiesMap[strategy](filteredInputs);
};

export { QueryParamsStrategies, getSearchToolsQueryParams };
